var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 223,
    viewBox: "0 0 193 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4144 221.053C146.932 221.053 187.885 180.083 187.885 129.544C187.885 79.0058 146.932 38.0361 96.4144 38.0361C45.8963 38.0361 4.94336 79.0058 4.94336 129.544C4.94336 180.083 45.8963 221.053 96.4144 221.053Z",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M21.6807 160.696C22.7847 159.575 23.8244 158.392 24.7946 157.153C26.287 153.54 28.6643 150.361 31.7075 147.908C36.2688 144.174 41.639 141.558 47.3899 140.268C53.1408 138.978 59.1135 139.05 64.8317 140.479C68.8564 141.522 72.2739 137.418 74.0099 133.633C77.3496 126.328 78.8443 118.322 81.5456 110.744C84.2469 103.167 88.5052 95.6513 95.5582 91.7651C97.6211 90.6202 99.8554 89.8259 101.895 88.6499C106.566 85.9631 109.68 81.2591 111.104 75.9633C112.763 75.0288 115.674 76.4773 117.877 77.1471C119.566 77.6611 119.691 78.1517 120.547 79.7015C121.404 81.2513 121.326 83.5955 120.617 84.2263C119.636 85.0908 118.282 85.7839 117.433 86.7107C116.629 87.5662 116.011 88.5801 115.62 89.6876C115.228 90.7952 115.072 91.9721 115.16 93.1435C115.363 96.9674 116.865 100.698 116.6 104.522C116.393 106.376 115.991 108.203 115.402 109.973C113.585 116.204 112.028 122.496 110.731 128.851C110.061 132.068 109.454 135.409 110.178 138.617C111.618 145.035 118.064 149.24 124.502 150.556C130.94 151.872 137.604 151.016 144.174 151.07C154.224 151.156 164.111 153.407 173.904 155.634C174.489 155.701 175.036 155.958 175.461 156.366C176.169 157.238 175.516 158.554 174.683 159.302C170.852 162.744 164.928 161.163 159.829 160.478C152.309 159.473 144.703 160.922 137.207 162.036C129.71 163.149 121.917 164.037 114.631 161.888C107.344 159.738 100.688 153.866 99.8398 146.312C99.2715 150.206 96.7259 153.547 93.8611 156.234C82.5732 166.771 64.5125 169.247 50.8191 162.129C45.9303 159.653 39.9749 161.335 34.907 163.391C29.8391 165.447 24.4832 167.908 19.1195 166.841C18.3522 166.749 17.6346 166.413 17.0721 165.883C15.6086 164.24 17.5859 161.576 19.7423 161.156C20.4138 161.142 21.0746 160.986 21.6807 160.696Z",
    fill: "#FBB500",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6807 160.696C22.7847 159.575 23.8244 158.392 24.7946 157.153C26.287 153.54 28.6643 150.361 31.7075 147.908C36.2688 144.174 41.639 141.558 47.3899 140.268C53.1408 138.978 59.1135 139.05 64.8317 140.479C68.8564 141.522 72.2739 137.418 74.0099 133.633C77.3496 126.328 78.8443 118.322 81.5456 110.744C84.2469 103.167 88.5052 95.6513 95.5582 91.7651C97.6211 90.6202 99.8554 89.8259 101.895 88.6499C106.566 85.9631 109.68 81.2591 111.104 75.9633C112.763 75.0288 115.674 76.4773 117.877 77.1471C119.566 77.6611 119.691 78.1517 120.547 79.7015C121.404 81.2513 121.326 83.5955 120.617 84.2263C119.636 85.0908 118.282 85.7839 117.433 86.7107C116.629 87.5662 116.011 88.5801 115.62 89.6876C115.228 90.7952 115.072 91.9721 115.16 93.1435C115.363 96.9674 116.865 100.698 116.6 104.522C116.393 106.376 115.991 108.203 115.402 109.973C113.585 116.204 112.028 122.496 110.731 128.851C110.061 132.068 109.454 135.409 110.178 138.617C111.618 145.035 118.064 149.24 124.502 150.556C130.94 151.872 137.604 151.016 144.174 151.07C154.224 151.156 164.111 153.407 173.904 155.634C174.489 155.701 175.036 155.958 175.461 156.366C176.169 157.238 175.516 158.554 174.683 159.302C170.852 162.744 164.928 161.163 159.829 160.478C152.309 159.473 144.703 160.922 137.207 162.036C129.71 163.149 121.917 164.037 114.631 161.888C107.344 159.738 100.688 153.866 99.8398 146.312C99.2715 150.206 96.7259 153.547 93.8611 156.234C82.5732 166.771 64.5125 169.247 50.8191 162.129C45.9303 159.653 39.9749 161.335 34.907 163.391C29.8391 165.447 24.4832 167.908 19.1195 166.841C18.3522 166.749 17.6346 166.413 17.0721 165.883C15.6086 164.24 17.5859 161.576 19.7423 161.156C20.4138 161.142 21.0746 160.986 21.6807 160.696V160.696Z",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M115.16 93.1435C115.861 92.8943 115.799 88.4708 117.434 86.7107C118.282 85.7917 119.637 85.0908 120.617 84.2263C121.326 83.5955 121.396 81.2513 120.547 79.7015C119.699 78.1517 119.567 77.6611 117.877 77.1471C115.674 76.4773 112.763 75.0288 111.104 75.9633C109.649 81.2591 101.864 87.4895 101.895 88.6499C101.926 89.8103 113.541 93.7198 115.16 93.1435Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.6198 137.068C70.8535 137.642 70.0026 138.094 69.0975 138.407C66.0303 139.606 63.1188 138.976 59.8258 138.913C56.5329 138.851 52.8195 139.248 50.6009 136.818C49.9509 136.187 49.5106 135.372 49.3397 134.482C49.2694 134.033 49.3412 133.573 49.5449 133.167C49.7487 132.76 50.0744 132.428 50.4763 132.216C51.2548 131.873 52.2201 132.216 53.0609 132.504C56.6574 133.727 60.5265 133.851 64.3176 133.766C65.3615 133.772 66.4037 133.683 67.4316 133.501C68.7083 133.236 74.6091 128.828 75.4032 129.607C76.1972 130.386 72.4839 136.328 71.6198 137.068Z",
    fill: "#FBB500",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6198 137.068C70.8535 137.642 70.0026 138.094 69.0975 138.407C66.0303 139.606 63.1188 138.976 59.8258 138.913C56.5329 138.851 52.8195 139.248 50.6009 136.818C49.9509 136.187 49.5106 135.372 49.3397 134.482C49.2694 134.033 49.3412 133.573 49.5449 133.167C49.7487 132.76 50.0744 132.428 50.4763 132.216C51.2548 131.873 52.2201 132.216 53.0609 132.504C56.6574 133.727 60.5265 133.851 64.3176 133.766C65.3615 133.772 66.4037 133.683 67.4316 133.501C68.7083 133.236 74.6091 128.828 75.4032 129.607C76.1972 130.386 72.4839 136.328 71.6198 137.068Z",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M121.637 139.575C123.729 139.888 125.845 140.003 127.959 139.918C137.526 139.84 147.304 139.809 156.373 142.854C157.041 142.995 157.628 143.392 158.008 143.96C158.428 144.825 157.751 145.899 156.856 146.296C155.931 146.575 154.95 146.612 154.006 146.406C144.236 145.175 139.737 149.824 129.874 149.824H122.089C119.629 149.824 114.117 145.642 112.747 143.594C111.19 141.258 109.633 137.364 110.412 134.249C110.412 134.249 114.016 136.671 115.557 137.457C117.47 138.455 119.518 139.169 121.637 139.575Z",
    fill: "#FBB500",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.637 139.575C123.729 139.888 125.845 140.003 127.959 139.918C137.526 139.84 147.304 139.809 156.373 142.854C157.041 142.995 157.628 143.392 158.008 143.96C158.428 144.825 157.751 145.899 156.856 146.296C155.931 146.575 154.95 146.612 154.006 146.406C144.236 145.175 139.737 149.824 129.874 149.824H122.089C119.629 149.824 114.117 145.642 112.747 143.594C111.19 141.258 109.633 137.364 110.412 134.249C110.412 134.249 114.016 136.671 115.557 137.457C117.47 138.455 119.518 139.169 121.637 139.575V139.575Z",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24 98.0034C111.091 99.8641 111.746 101.809 112.194 103.805C112.663 105.849 112.74 107.963 112.42 110.036C112.223 111.084 111.904 112.106 111.47 113.081C111.027 114.011 110.533 114.915 109.991 115.791C108.957 117.537 107.835 119.23 106.628 120.861C107.282 118.93 108.076 117.061 108.909 115.223C109.816 113.504 110.484 111.67 110.894 109.771C111.189 107.85 111.223 105.899 110.995 103.969C110.801 102.022 110.458 100.036 110.24 98.0034Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3003 107.738C94.5901 107.738 95.6357 106.692 95.6357 105.402C95.6357 104.111 94.5901 103.065 93.3003 103.065C92.0104 103.065 90.9648 104.111 90.9648 105.402C90.9648 106.692 92.0104 107.738 93.3003 107.738Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.642 109.296C103.932 109.296 104.978 108.25 104.978 106.959C104.978 105.669 103.932 104.623 102.642 104.623C101.352 104.623 100.307 105.669 100.307 106.959C100.307 108.25 101.352 109.296 102.642 109.296Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7853 116.04C99.4056 115.433 98.9101 114.907 98.327 114.491C97.744 114.076 97.0848 113.779 96.3872 113.619C95.6895 113.458 94.9671 113.437 94.2612 113.556C93.5552 113.674 92.8796 113.931 92.2729 114.311",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65039 9.94531L10.9921 19.2908",
    stroke: "#0C568F",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9541 19.127L11.2958 10.1709",
    stroke: "#0C568F",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.321 29.415L138.663 38.7606",
    stroke: "#0C568F",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.624 38.5968L138.966 29.6406",
    stroke: "#0C568F",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.98 19.5088L150.503 24.1816",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.128 24.1036L150.651 19.6255",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.993 49.8818L164.516 54.5546",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.141 54.4766L164.664 49.9985",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6514 46.7666L32.1743 51.4394",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7993 51.3614L32.3223 46.8833",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4678 2.37549L74.9907 7.04826",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6157 6.97026L75.1387 2.49219",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.942 28.0757L108.465 32.7484",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09 32.6705L108.613 28.1924",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.461 77.1396L190.984 81.8124",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.609 81.7344L191.132 77.2563",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07568 74.8032L9.59863 79.476",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22363 79.398L9.74658 74.9199",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.536 1.37842L128.986 8.83148",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.777 8.69916L129.235 1.55762",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.137 30.1938L179.587 37.6469",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.378 37.5146L179.836 30.373",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1626 24.7422L84.6126 32.1952",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4038 32.0629L84.8616 24.9214",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65674 48.8848L16.1068 56.3378",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89795 56.2055L16.3558 49.064",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4438 23.4028L57.7551 35.0847",
    stroke: "#0C568F",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8174 34.8822L58.1209 23.6831",
    stroke: "#0C568F",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.542 6.65869L102.588 16.0042",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8374 15.8404L102.883 6.88428",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.288 50.271L191.334 59.6165",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.584 59.4532L191.63 50.4971",
    stroke: "#0C568F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 223,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.99c0c90b4aef95c64cbd78c1c3585a7d.svg";
export { ForwardRef as ReactComponent };